var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:{'isVisible' : _vm.isVisible},attrs:{"id":"footer"}},[(_vm.isVisible)?_c('span',[_vm._v("Copyright "),_c('strong',[_vm._v("Effis Tecnologia")]),_vm._v(" © 2020")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }